module.exports = "<div class=\"modal-detail-container hide-modal-detail\">\r\n    <div class=\"modal-detail\" [style.width]=\"isAlert ? '400px' : ''\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"modal-detail-mask\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-detail/modal-detail.component.html
// module id = ./src/app/shared/components/modal-detail/modal-detail.component.html
// module chunks = main